import React, { FC, useEffect } from "react";
import { Link } from "@sitecore-jss/sitecore-jss-react";
import { FooterLink, LinkField } from "../../../../types/types";
import { FooterLinkModel } from "../../../../lib/shared-models/FooterLink.model";

const SocialMedia: FC<FooterLink> = (props) => {
  const model = new FooterLinkModel(props);

  useEffect(() => {
    if (typeof window !== 'undefined' && 'customElements' in window) {
      import('@patternfly/pfe-icon-onhighway/dist/pfe-icon.js');
    }
  }, []);

  const socialLinks = model.list.map((item, i) => {
    return (
      <Link field={item.fields?.Link as LinkField} key={i} title={item.displayName}>
        <pfe-icon icon={item.fields?.Icon?.value} size="24" color="base" />
      </Link>
    );
  });
  return <div>{socialLinks}</div>;
};

export default SocialMedia;
